import {
  KeyframeConfig,
  BLOCK_REVEAL_ANIMATIONS,
} from "../../../models/animations.model";

const BLOCK_RECT_BUFFER_POSITION = 1;

export const getBlockRevealInMainObjectKeyframes = (
  fabricObject: any,
  duration: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 0,
            duration: 1,
          },
          {
            opacity: 0,
            duration: duration / 2,
          },
        ],
      },
    },
    {
      offset: duration / 2,
      option: {
        targets: fabricObject,
        keyframes: [
          {
            duration: 1,
          },
          {
            duration: duration / 2,
          },
        ],
      },
    },
  ];
};

export const getBlockRevealOutMainObjectKeyframes = (
  fabricObject: any,
  duration: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: fabricObject,
        keyframes: [
          {
            duration: 1,
          },
          {
            duration: duration / 2,
          },
        ],
      },
    },
    {
      offset: duration / 2,
      option: {
        targets: fabricObject,
        keyframes: [
          {
            opacity: 0,
            duration: 1,
          },
          {
            opacity: 0,
            duration: duration / 2,
          },
        ],
      },
    },
  ];
};

export const getBlockRevealFromLeftBaseKeyframe = (
  clipPathLeft: number,
  blockRect: any,
  duration: number,
  canvas: fabric.Canvas
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: blockRect,
        keyframes: [
          {
            width: 0,
            duration: 1,
          },
          {
            width: blockRect.width,
            duration: duration / 2,
          },
        ],
      },
    },
    {
      offset: duration / 2,
      option: {
        targets: blockRect.clipPath,
        complete: () => {
          canvas.remove(blockRect);
        },
        keyframes: [
          {
            left: clipPathLeft - BLOCK_RECT_BUFFER_POSITION,
            duration: 1,
          },
          {
            left: clipPathLeft + blockRect.width + BLOCK_RECT_BUFFER_POSITION,
            duration: duration / 2,
          },
        ],
      },
    },
  ];
};

export const getBlockRevealFromRightBaseKeyframe = (
  clipPathLeft: number,
  blockRect: any,
  duration: number,
  canvas: fabric.Canvas
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: blockRect,
        keyframes: [
          {
            duration: 1,
          },
          {
            duration: duration / 2,
          },
        ],
      },
    },
    {
      option: {
        targets: blockRect.clipPath,
        keyframes: [
          {
            left: clipPathLeft + blockRect.width + BLOCK_RECT_BUFFER_POSITION,
            duration: 1,
          },
          {
            left: clipPathLeft - BLOCK_RECT_BUFFER_POSITION,
            duration: duration / 2,
          },
        ],
      },
    },
    {
      offset: duration / 2,
      option: {
        targets: blockRect,
        complete: () => {
          canvas.remove(blockRect);
        },
        keyframes: [
          {
            width: blockRect.width,
            duration: 1,
          },
          {
            width: 0,
            duration: duration / 2,
          },
        ],
      },
    },
  ];
};

export const getBlockRevealFromTopBaseKeyframe = (
  clipPathTop: number,
  blockRect: any,
  duration: number,
  canvas: fabric.Canvas
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: blockRect,
        keyframes: [
          {
            height: 0,
            duration: 1,
          },
          {
            height: blockRect.height,
            duration: duration / 2,
          },
        ],
      },
    },
    {
      offset: duration / 2,
      option: {
        targets: blockRect.clipPath,
        complete: () => {
          canvas.remove(blockRect);
        },
        keyframes: [
          {
            top: clipPathTop - BLOCK_RECT_BUFFER_POSITION,
            duration: 1,
          },
          {
            top: clipPathTop + blockRect.height + BLOCK_RECT_BUFFER_POSITION,
            duration: duration / 2,
          },
        ],
      },
    },
  ];
};

export const getBlockRevealFromBottomBaseKeyframe = (
  clipPathTop: number,
  blockRect: any,
  duration: number,
  canvas: fabric.Canvas
): KeyframeConfig[] => {
  return [
    {
      option: {
        targets: blockRect,
        keyframes: [
          {
            duration: 1,
          },
          {
            duration: duration / 2,
          },
        ],
      },
    },
    {
      option: {
        targets: blockRect.clipPath,
        keyframes: [
          {
            top: clipPathTop + blockRect.height + BLOCK_RECT_BUFFER_POSITION,
            duration: 1,
          },
          {
            top: clipPathTop - BLOCK_RECT_BUFFER_POSITION,
            duration: duration / 2,
          },
        ],
      },
    },
    {
      offset: duration / 2,
      option: {
        targets: blockRect,
        complete: () => {
          canvas.remove(blockRect);
        },
        keyframes: [
          {
            height: blockRect.height,
            duration: 1,
          },
          {
            height: 0,
            duration: duration / 2,
          },
        ],
      },
    },
  ];
};

export const getBlockRevealBaseKeyframe = (
  fabricObject: any,
  duration: number,
  canvas: fabric.Canvas,
  blockRect: any,
  type: BLOCK_REVEAL_ANIMATIONS
): KeyframeConfig[] => {
  let specificKeyframeConfig: KeyframeConfig[] = [];
  const blockRevealInMainObjectKeyframes = getBlockRevealInMainObjectKeyframes(
    fabricObject,
    duration
  );
  const blockRevealOutMainObjectKeyframes =
    getBlockRevealOutMainObjectKeyframes(fabricObject, duration);

  switch (type) {
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_IN_BOTTOM:
      specificKeyframeConfig = getBlockRevealFromBottomBaseKeyframe(
        blockRect.clipPath.top,
        blockRect,
        duration,
        canvas
      );
      return blockRevealInMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_IN_RIGHT:
      specificKeyframeConfig = getBlockRevealFromRightBaseKeyframe(
        blockRect.clipPath.left,
        blockRect,
        duration,
        canvas
      );
      return blockRevealInMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_IN_TOP:
      specificKeyframeConfig = getBlockRevealFromTopBaseKeyframe(
        blockRect.clipPath.top,
        blockRect,
        duration,
        canvas
      );
      return blockRevealInMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_IN_LEFT:
      specificKeyframeConfig = getBlockRevealFromLeftBaseKeyframe(
        blockRect.clipPath.left,
        blockRect,
        duration,
        canvas
      );
      return blockRevealInMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_OUT_BOTTOM:
      specificKeyframeConfig = getBlockRevealFromTopBaseKeyframe(
        blockRect.clipPath.top,
        blockRect,
        duration,
        canvas
      );
      return blockRevealOutMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_OUT_RIGHT:
      specificKeyframeConfig = getBlockRevealFromLeftBaseKeyframe(
        blockRect.clipPath.left,
        blockRect,
        duration,
        canvas
      );
      return blockRevealOutMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_OUT_TOP:
      specificKeyframeConfig = getBlockRevealFromBottomBaseKeyframe(
        blockRect.clipPath.top,
        blockRect,
        duration,
        canvas
      );
      return blockRevealOutMainObjectKeyframes.concat(specificKeyframeConfig);
    case BLOCK_REVEAL_ANIMATIONS.BLOCK_REVEAL_OUT_LEFT:
      specificKeyframeConfig = getBlockRevealFromRightBaseKeyframe(
        blockRect.clipPath.left,
        blockRect,
        duration,
        canvas
      );
      return blockRevealOutMainObjectKeyframes.concat(specificKeyframeConfig);
  }
};
